<template>
  <div class="customfields-settings">
    <ButtonComponent
      class="customfields-settings__trigger"
      :label="$tc('adaptation', 2)"
      @click.stop="show = true"
      :icon="['fal', 'sliders-h']"
    >
    </ButtonComponent>

    <MountingPortal mountTo="#portals" append>
      <ModalComponent :show="show" @close="show = false" :clickaway="true">
        <Card class="customfields-settings__content" sublabel="'fjfjfj'" theme="border">
          <template #header>
            <label class="customfields-settings__label">
              {{ `${$t('settingsFor')} ${schema.label.toLowerCase()}` }}</label
            >
            <span v-if="item.settingsSubLabel"> {{ item.settingsSubLabel }}</span>
          </template>
          <template #default>
            <Field
              :parent-index="parentIndex"
              :key="item.key"
              :schema="item"
              :value="value"
              v-on="{
                ...$listeners,
                input: $ev => $emit('input', $ev),
              }"
            />
          </template>

          <template #footer>
            <ButtonComponent
              :label="$t('cancel')"
              @click.stop="show = false"
              :icon="['fal', 'times']"
            />
            <ButtonComponent
              theme="primary"
              :label="$t('confirm')"
              @click.stop="show = false"
              :icon="['fal', 'arrow-right']"
            />
          </template>
        </Card>
      </ModalComponent>
    </MountingPortal>
  </div>
</template>

<script>
import { ModalComponent } from 'vue-elder-modal'
import Card from '@kvass/card'
import Renderer from './Renderer'
import { MountingPortal } from 'portal-vue'

export default {
  props: {
    config: Object,
    schema: Object,
    value: undefined,
    parentIndex: Number,
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    item() {
      const schema = this.schema
      let base = {
        ...this.schema,
        component: schema.settings,
        settings: null,
        label: ``,
        settingsSubLabel: this.$path('options.props._parent.settingsSubLabel', schema),

        options: {
          ...schema.options,
          props: {
            ...schema.options.props,

            _parent: null,
          },
          collapsible: false,
          layout: schema.options.settingsLayout,
        },
        isList: false,
        isSettings: true,
        parentIsList: Boolean(this.config.isList),
        index: this.parentIndex,
      }

      return base
    },
  },

  components: {
    ModalComponent,
    Card,
    Renderer,
    Field: () => import('./Field.vue'),
    MountingPortal,
  },
}
</script>

<style lang="scss">
.customfields-settings {
  &__trigger {
    display: flex;
    gap: 0.3rem;

    padding: 0;
    --vue-elder-button-padding-y: 0.5rem;
    --vue-elder-button-padding-x: 0.75rem;
  }
  &__label {
    font-size: 1.3rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  &__content {
    width: 100%;
    max-width: 1000px;

    .field-dynamic {
      .field-dynamic__items {
        padding: 0;
      }

      & > .elder-input__wrapper {
        & > .elder-input__field {
          border: none;
        }
      }

      & > label {
        font-size: 1.3rem;
        margin-bottom: 1rem;
      }
    }
    .kvass-card {
      &__footer {
        background-color: white;
        &-content {
          justify-content: center;
          align-items: center;
        }
      }

      &__header {
        align-items: start;
        min-height: 100px;
      }
    }

    .field-renderer > .field-renderer__item {
      padding: 0.5rem 0 !important;
    }
  }
}
</style>
